/**
 * HTTP layer for a user's sectioned settings document. The odl_app user-settings
 * read/write surface.
 *
 * Contains:
 * - fetchUserSettings: read a user's settings sections
 * - patchUserSettings: write a user's settings sections
 */
import apiClient from '@sophocles/http-common';

// Consolidated user-settings endpoint.  See
// `pliny.odl_app.views.settings.UserSettingsViewSet` for the
// backend.  When `userId` is omitted the request hits `/me/`; with
// `userId` it hits `/{userId}/` and the request is gated by
// `UserPermission.can_see_user`.
const path = userId => (userId ? `odl-app/user-settings/${userId}/` : 'odl-app/user-settings/me/');

export const fetchUserSettings = (userId = null) => apiClient.get(path(userId)).then(res => res.data);

export const patchUserSettings = (payload, userId = null) =>
  apiClient.patch(path(userId), payload).then(res => res.data);
